package com.evoapps.evoshift.viewmodels

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.evoapps.evoshift.settings.AppLanguageSettings
import com.evoapps.evoshift.util.APP_LANGUAGES
import com.evoapps.evoshift.util.appLanguage
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn

/**
 * The language picker (SH-137) in Profile and on the sign-in screen: the device's language or
 * one of [APP_LANGUAGES]. Picking applies at once (the whole app switches, nothing to wait for);
 * the profile follows through ProfileLanguageSync.
 */
class LanguageViewModel(
    private val settings: AppLanguageSettings,
    /** The language the app shows now (picked, else the device's). */
    private val shown: () -> String = ::appLanguage
) : ViewModel() {

    data class UiState(
        /** The picked language; null: the device's. */
        val picked: String?,
        /** What the app shows: [picked], or the device's language when it is translated (else English). */
        val shown: String
    )

    val options: List<String?> = listOf(null) + APP_LANGUAGES

    val state: StateFlow<UiState> = settings.preference
        .map { UiState(it, shown()) }
        .stateIn(viewModelScope, SharingStarted.Eagerly, UiState(settings.preference.value, shown()))

    fun choose(language: String?) = settings.choose(language)
}
